import React, { useEffect } from "react";
import { Images } from "../../assets";
import { Button } from "../../components";
import { formScreenProps, stages } from "./Index";
import { useNavigate } from "react-router-dom";
import AppDropDown from "../../components/AppDropdown";
import { toast } from "react-toastify";

interface VehicleSelectionprops extends formScreenProps {
  vehicles: string[];
  models: string[];
  years: string[];
}

export default function VehicleSelection({
  setCurrentStage,
  onChange,
  vehicles,
  models,
  years,
  form,
}: VehicleSelectionprops) {
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentStage(stages.vehicleSelection);
  }, []);

  const handleNextClicked = () => {
    console.log(form);
    if (!form?.vehicle?.year) return toast.warn("Please fill all fields");
    setCurrentStage(stages.commuteDistance);
  };

  //go back to the previous stage
  const handleBackClicked = () => {
    navigate(-1);
  };
  const fields = [
    {
      title: "Country",
      options: ["Portugal", "France", "England"],
    },
    {
      title: "Make",
      options: vehicles,
    },
    {
      title: "Model",
      options: models,
    },
    {
      title: "Year",
      options: years,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:gap-8">
      {/* Form Section */}
      <div className="md:max-w-[70%] justify-center place-self-center">
        <div className="mb-8">
          <p className="font-bold text-2xl mb-3">Vehicle Selection</p>
          <p>
            Help us understand your vehicle to accurately estimate your
            emissions. Choose your car details below.
          </p>
        </div>
        <div className="flex flex-col gap-4">
          {fields.map(({ options, title }) => (
            <AppDropDown
              key={title}
              title={title}
              required={true}
              value={
                form?.vehicle &&
                form.vehicle[
                  title
                    .split(" ")
                    .join("_")
                    .toLowerCase() as keyof typeof form.vehicle
                ]
              }
              options={options}
              onChange={(v) => onChange("vehicle", v)}
            />
          ))}
        </div>
        <div className="flex gap-3 mt-6">
          <Button inverted title="Back" onClick={handleBackClicked} />
          <Button
            title="Continue to Commute Distance"
            onClick={handleNextClicked}
          />
        </div>
      </div>

      {/* Image Section */}
      <div className="hidden md:flex justify-center items-center">
        <img
          src={Images.placeholder_Image}
          alt="placeholder image"
          className="w-full max-w-[500px] h-auto"
        />
      </div>
    </div>
  );
}
